export default "__VITE_ASSET__54ea7fff__"